/* Kanela 21.10.2026: Kanela-Logo auf dem Gratis-Versand-Balken.
   Wandert mit dem Fortschritt nach rechts und schlägt einmal wie ein Herz, wenn der Gratis-Versand erreicht wird. */
(function(){
  if (customElements.get('kel-ship-logo')) return;
  var KEY = 'kelFsgPercent';
  function readPrev(){ try { var v = parseFloat(sessionStorage.getItem(KEY)); return isNaN(v) ? null : v; } catch(e){ return null; } }
  function savePrev(v){ try { sessionStorage.setItem(KEY, String(v)); } catch(e){} }
  class KelShipLogo extends HTMLElement {
    connectedCallback(){
      var goal = this.closest('free-shipping-goal');
      this.bar = goal ? goal.querySelector('progress-bar') : null;
      this.goalEl = goal;
      if (!this.bar) return;
      var start = readPrev();
      this.current = start === null ? this.compute() : start;
      this.place(this.current, false);
      var self = this;
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ self.update(); }); });
      this.observer = new MutationObserver(function(){ self.update(); });
      this.observer.observe(this.bar, { attributes: true, attributeFilter: ['style', 'data-value'] });
    }
    disconnectedCallback(){ if (this.observer) this.observer.disconnect(); }
    compute(){
      var v = parseFloat(this.bar.style.getPropertyValue('--percent'));
      if (!isNaN(v)) return Math.max(0, Math.min(100, v));
      var g = this.goalEl;
      var goal = Number(g.dataset.minimumAmount) * Number((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1);
      var total = Number(g.dataset.cartTotal) / 100;
      if (!goal) return 0;
      return Math.max(0, Math.min(100, total * 100 / goal));
    }
    place(p, animate){
      this.classList.toggle('is-instant', !animate);
      this.style.left = 'calc((100% - 26px) * ' + (p / 100) + ')';
    }
    update(){
      var p = this.compute();
      var before = this.current;
      this.place(p, true);
      if (p >= 100 && before < 100) {
        var el = this;
        el.classList.remove('is-pop'); void el.offsetWidth;
        setTimeout(function(){ el.classList.add('is-pop'); }, 650);
        setTimeout(function(){ el.classList.remove('is-pop'); }, 2000);
      }
      this.current = p;
      savePrev(p);
    }
  }
  customElements.define('kel-ship-logo', KelShipLogo);
})();

/* Kanela 21.10.2026: «Weiter einkaufen» schliesst den Warenkorb. */
document.addEventListener('click', function(e){
  var b = e.target.closest && e.target.closest('[data-kel-close-cart]');
  if (!b) return;
  e.preventDefault();
  var d = document.querySelector('cart-drawer');
  if (d && typeof d.hide === 'function') d.hide();
});

/* Kanela 21.10.2026: Passende Vorschläge bis zum Gratis-Versand.
   Erscheint nur, wenn noch höchstens data-max-gap CHF fehlen. Höchstens 3 Artikel,
   an Lager, nicht im Warenkorb, aus den Shopify-Empfehlungen zum teuersten Artikel. */
(function(){
  if (customElements.get('kel-topup')) return;
  // Kanela 22.10.2026: Vorschläge sind bei jedem Öffnen des Warenkorbs zugeklappt, der Kunde klappt selbst auf.
  var state = { open: false };
  var watched = new WeakSet();
  function watchDrawer(el){
    var d = el.closest('cart-drawer');
    if (!d || watched.has(d)) return;
    watched.add(d);
    var wasOpen = d.hasAttribute('open');
    new MutationObserver(function(){
      var nowOpen = d.hasAttribute('open');
      if (nowOpen && !wasOpen) {
        state.open = false;
        document.querySelectorAll('kel-topup').forEach(function(t){ t.render(); });
      }
      wasOpen = nowOpen;
    }).observe(d, { attributes: true, attributeFilter: ['open'] });
  }
  var CART_SVG = '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M6.875 18.125C7.56536 18.125 8.125 17.5654 8.125 16.875C8.125 16.1846 7.56536 15.625 6.875 15.625C6.18464 15.625 5.625 16.1846 5.625 16.875C5.625 17.5654 6.18464 18.125 6.875 18.125Z" fill="currentColor"/><path d="M15 18.125C15.6904 18.125 16.25 17.5654 16.25 16.875C16.25 16.1846 15.6904 15.625 15 15.625C14.3096 15.625 13.75 16.1846 13.75 16.875C13.75 17.5654 14.3096 18.125 15 18.125Z" fill="currentColor"/><path d="M1.25 2.5H3.125L5.99609 12.8344C6.06916 13.0976 6.22643 13.3296 6.44384 13.4949C6.66126 13.6603 6.92685 13.7499 7.2 13.75H14.9219C15.1952 13.7501 15.4609 13.6605 15.6785 13.4952C15.8961 13.3298 16.0535 13.0977 16.1266 12.8344L18.125 5.625H3.99297" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var EXCLUDE_TYPES = ['Erotik'];
  function root(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function money(c){
    try { return FoxTheme.Currency.formatMoney(c, FoxTheme.settings.moneyFormat); }
    catch(e){ return 'CHF ' + (c/100).toFixed(2); }
  }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]; }); }
  function img(u){ if (!u) return ''; u = u.indexOf('//') === 0 ? 'https:' + u : u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=200'; }
  var cache = {};
  function recs(pid, intent){
    var key = pid + intent;
    if (cache[key]) return cache[key];
    cache[key] = fetch(root() + 'recommendations/products.json?product_id=' + pid + '&limit=10&intent=' + intent)
      .then(function(r){ return r.ok ? r.json() : { products: [] }; })
      .then(function(d){ return d.products || []; })
      .catch(function(){ return []; });
    return cache[key];
  }
  class KelTopup extends HTMLElement {
    connectedCallback(){
      var self = this;
      watchDrawer(this);
      this.render();
      this._onUpd = function(){ setTimeout(function(){ self.render(); }, 50); };
      document.addEventListener('cart:updated', this._onUpd);
    }
    disconnectedCallback(){ document.removeEventListener('cart:updated', this._onUpd); }
    hideMe(){ this.hidden = true; this.innerHTML = ''; }
    render(){
      var self = this;
      var isOpen = state.open;
      fetch(root() + 'cart.js').then(function(r){ return r.json(); }).then(function(cart){
        var goal = Number(self.dataset.goal) * 100 * Number((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1);
        var gap = goal - cart.total_price;
        // Kanela 22.10.2026: keine CHF-40-Grenze mehr, Vorschläge solange der Gratis-Versand noch nicht erreicht ist.
        if (!cart.items.length || gap <= 0) return self.hideMe();
        var inCart = {}; cart.items.forEach(function(i){ inCart[i.product_id] = true; });
        var base = cart.items.slice().sort(function(a,b){ return b.final_price - a.final_price; })[0];
        var types = {}; var vendors = {};
        cart.items.forEach(function(i){ if (i.product_type) types[i.product_type] = true; if (i.vendor) vendors[i.vendor] = true; });
        Promise.all([recs(base.product_id, 'complementary'), recs(base.product_id, 'related')]).then(function(res){
          var seen = {}; var list = [];
          res[0].forEach(function(p){ p._comp = true; });
          res[0].concat(res[1]).forEach(function(p){
            if (seen[p.id] || inCart[p.id] || !p.available) return;
            if (EXCLUDE_TYPES.indexOf(p.type) > -1) return;
            if ((p.tags || []).some(function(t){ return /erotik/i.test(t); })) return;
            var fits = p._comp || (p.type && types[p.type]) || (p.vendor && vendors[p.vendor]);
            if (!fits) return;
            if (p.price > gap + 2000) return;
            seen[p.id] = true; list.push(p);
          });
          var lo = gap, hi = gap + 1500;
          list.sort(function(a,b){
            function score(p){ var s = 0; if (p._comp) s -= 1000000; if (p.price >= lo && p.price <= hi) s -= 100000; else if (p.price < lo) s -= 50000; return s + Math.abs(p.price - lo) / 10; }
            return score(a) - score(b);
          });
          list = list.slice(0, 3);
          if (!list.length) return self.hideMe();
          if (!isOpen) return self.paintCollapsed();
          self.paint(list);
        });
      }).catch(function(){ self.hideMe(); });
    }
    paintCollapsed(){
      var self = this;
      this.innerHTML = '<button type="button" class="kel-topup__show">+ ' + esc(this.dataset.show || 'Vorschläge anzeigen') + '</button>';
      this.classList.add('is-collapsed');
      this.hidden = false;
      this.querySelector('.kel-topup__show').addEventListener('click', function(){
        state.open = true;
        self.render();
      });
    }
    paint(list){
      var self = this;
      var html = '<div class="kel-topup__head"><b>' + esc(this.dataset.head) + '</b><button type="button" class="kel-topup__hide">' + esc(this.dataset.hide) + '</button></div><div class="kel-topup__row">';
      list.forEach(function(p){
        var v = (p.variants || []).filter(function(x){ return x.available; })[0] || p.variants[0];
        html += '<div class="kel-topup__card"><a href="' + esc(p.url) + '"><img class="kel-topup__img" src="' + esc(img(p.featured_image)) + '" alt="" loading="lazy"><div class="kel-topup__name">' + esc(p.title) + '</div></a>'
          + '<div class="kel-topup__foot"><span>' + money(v.price) + '</span><button type="button" class="kel-topup__add" data-variant="' + v.id + '" aria-label="' + esc(self.dataset.add + ': ' + p.title) + '">' + CART_SVG + '</button></div></div>';
      });
      html += '</div>';
      this.innerHTML = html;
      this.classList.remove('is-collapsed');
      this.hidden = false;
      this.querySelector('.kel-topup__hide').addEventListener('click', function(){
        state.open = false;
        self.paintCollapsed();
      });
      this.querySelectorAll('.kel-topup__add').forEach(function(btn){
        btn.addEventListener('click', function(){ self.add(btn); });
      });
    }
    add(btn){
      var self = this;
      btn.disabled = true;
      var drawer = document.querySelector('cart-drawer');
      var sid = this.dataset.sectionId;
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }], sections: sid, sections_url: window.location.pathname })
      }).then(function(r){ return r.json(); }).then(function(payload){
        return fetch(root() + 'cart.js').then(function(r){ return r.json(); }).then(function(cart){
          cart.sections = payload.sections;
          if (window.FoxTheme && FoxTheme.pubsub) {
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        });
      }).catch(function(){ btn.disabled = false; });
    }
  }
  customElements.define('kel-topup', KelTopup);
})();
